import React, { PropsWithChildren } from "react";

import { ButtonPropsProvider, ProvidedButtonProps } from "../Button";
import styles from "./styles.module.scss";

type ButtonSetDirectProps =
  | { direction: "vertical"; align?: "start" }
  | { direction?: "horizontal"; align?: "start" | "end" | "stretch" | "space-between" };

export type ButtonSetProps = ButtonSetDirectProps &
  Partial<ProvidedButtonProps> & { className?: string; ghost?: boolean };

/** Wrap a list of buttons in this to make them full-width and vertically stacked instead of the normal horizontal arrangement */
export default function ButtonSet({
  direction,
  align,
  children,
  className,
  ghost,
  ...buttonProps
}: PropsWithChildren<ButtonSetProps>) {
  return (
    <div
      className={`
        ${className ?? ""}
        ${styles.ButtonSet}
        ${styles[direction ?? "horizontal"]}
        ${styles[align ?? "start"]}
        ${ghost ? styles.ghost : ""}
      `}
    >
      <ButtonPropsProvider {...buttonProps}>{children}</ButtonPropsProvider>
    </div>
  );
}

export function Spacer() {
  return <div className={styles.Spacer} />;
}
